import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { LanguageComponent } from '@components/language/language.component';
import { HeaderComponent } from '@core/header/header.component';
import { FooterComponent } from '@core/footer/footer.component';
import { ScrollTopButtonComponent } from '@core/scroll-top-button/scroll-top-button.component';

// Page components
import { IndexComponent } from './modules/index/pages/index/index.component';
import { ChildrenComponent } from './modules/children/children.component';
import { VirtualMuseumComponent } from './modules/virtual-museum/virtual-museum.component';
import { CollectionComponent } from './modules/collection/collection.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    LanguageComponent,
    HeaderComponent,
    FooterComponent,
    ScrollTopButtonComponent,
    IndexComponent,
    ChildrenComponent,
    VirtualMuseumComponent,
    CollectionComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
